import fastdom from 'fastdom';
import { onArticleCountResultsLoaded$ } from 'features/articleSearchResultsFacets';

// function to display the most popular section when there are no results
const displayMostRecenteArticles = function(countResults) {
    const mostPopularSection = document.querySelector('[data-component="blog-article-search-results-most-popular"]');
    if(mostPopularSection) {
        fastdom.mutate(() => {
            if(countResults > 0){
                mostPopularSection.setAttribute('hidden', '');
            }
            else{
                mostPopularSection.removeAttribute('hidden');
            }
        });
    }
};
    
onArticleCountResultsLoaded$.subscribe(displayMostRecenteArticles);